// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file dailyitems/unmark_daily_item.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.UnmarkDailyItemRequest
 */
export class UnmarkDailyItemRequest extends Message<UnmarkDailyItemRequest> {
  /**
   * The ID of the checklist this item belongs to
   *
   * @generated from field: int32 checklist_id = 1;
   */
  checklistId = 0;

  constructor(data?: PartialMessage<UnmarkDailyItemRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.UnmarkDailyItemRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "checklist_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnmarkDailyItemRequest {
    return new UnmarkDailyItemRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnmarkDailyItemRequest {
    return new UnmarkDailyItemRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnmarkDailyItemRequest {
    return new UnmarkDailyItemRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UnmarkDailyItemRequest | PlainMessage<UnmarkDailyItemRequest> | undefined, b: UnmarkDailyItemRequest | PlainMessage<UnmarkDailyItemRequest> | undefined): boolean {
    return proto3.util.equals(UnmarkDailyItemRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.UnmarkDailyItemResponse
 */
export class UnmarkDailyItemResponse extends Message<UnmarkDailyItemResponse> {
  constructor(data?: PartialMessage<UnmarkDailyItemResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.UnmarkDailyItemResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnmarkDailyItemResponse {
    return new UnmarkDailyItemResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnmarkDailyItemResponse {
    return new UnmarkDailyItemResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnmarkDailyItemResponse {
    return new UnmarkDailyItemResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UnmarkDailyItemResponse | PlainMessage<UnmarkDailyItemResponse> | undefined, b: UnmarkDailyItemResponse | PlainMessage<UnmarkDailyItemResponse> | undefined): boolean {
    return proto3.util.equals(UnmarkDailyItemResponse, a, b);
  }
}

